import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteSavedFilter, SavedFiltersV2Response } from "PFCore/services/filters";
import { Id } from "PFTypes/id";
import { MutationOptions } from "PFTypes/request_options";
import { PageTarget } from "PFTypes/saved_filters";

import { savedFiltersKeys } from "./query_keys";

export const useSavedFiltersDelete = (
  target: PageTarget,
  { onSuccess, ...queryParams }: MutationOptions<Id, null> = {}
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: savedFiltersKeys.removal(),
    mutationFn: (id: Id) => deleteSavedFilter(id),
    onSuccess: (...args) => {
      const removedId = args[1];
      queryClient.setQueryData(
        savedFiltersKeys.target(target),
        (savedFilters: SavedFiltersV2Response | undefined) =>
          savedFilters?.filter(({ id }) => id !== removedId) ?? []
      );
      onSuccess?.(...args);
    },
    ...queryParams
  });
};
